var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_83_100",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 11,
    width: 43,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9592 69.0005H60.1506L60.1506 11.6214L18.9592 11.6214L18.9592 69.0005Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_83_100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5443 69.0001C33.5952 69.0001 28.81 67.1248 25.2965 63.4174C18.3343 56.0456 18.9379 44.1904 18.9594 43.6946C18.9594 27.2698 38.2726 12.3969 39.0917 11.7718C39.415 11.5347 39.8677 11.5994 40.1048 11.9012C40.3419 12.2245 40.2772 12.6772 39.9754 12.9143C39.7814 13.0651 20.4251 27.9811 20.4251 43.7377C20.4251 43.8886 19.8432 55.5283 26.3743 62.4258C29.586 65.8315 34.0263 67.5559 39.5443 67.5559C39.9539 67.5559 40.2772 67.8792 40.2772 68.2888C40.2772 68.6983 39.9539 69.0216 39.5443 69.0216V69.0001Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5441 69.0006C39.1346 69.0006 38.8113 68.6772 38.8113 68.2677C38.8113 67.8581 39.1346 67.5348 39.5441 67.5348C45.0838 67.5348 49.5025 65.8104 52.7357 62.4048C59.2669 55.5072 58.6849 43.8891 58.6633 43.7813C58.6633 28.0032 39.307 13.0872 39.113 12.9363C38.7897 12.6992 38.7251 12.225 38.9837 11.9232C39.2208 11.5999 39.695 11.5352 39.9968 11.7939C40.8159 12.3974 60.1291 27.2703 60.1291 43.7382C60.1506 44.1909 60.7542 56.0461 53.7919 63.4178C50.3 67.1253 45.4933 69.0006 39.5441 69.0006Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2839 66.4129C29.1761 66.4129 29.0468 66.3914 28.9606 66.3267C28.7235 66.1974 28.551 65.9603 28.551 65.6801V22.3116C28.551 22.0314 28.7019 21.7943 28.939 21.665C29.1761 21.5357 29.4779 21.5572 29.6934 21.7081L39.9536 28.9721L59.8272 43.1337C60.0212 43.263 60.1289 43.5001 60.1289 43.7156C60.1289 43.9528 60.0212 44.1683 59.8272 44.3192L29.715 66.2836C29.5857 66.3698 29.4348 66.4129 29.2839 66.4129ZM30.0168 23.7558V64.2575L58.1459 43.7372L30.0168 23.7343V23.7558Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8045 66.4134C49.6536 66.4134 49.5028 66.3703 49.3734 66.284L19.2612 44.3196C19.0672 44.1903 18.9595 43.9532 18.9595 43.7161C18.9595 43.479 19.0672 43.2634 19.2612 43.1341L39.1133 28.9941L49.3734 21.7301C49.589 21.5792 49.8907 21.5576 50.1278 21.687C50.3649 21.8163 50.5158 22.0534 50.5158 22.3336V65.7021C50.5158 65.9823 50.3649 66.2194 50.1063 66.3487C49.9985 66.4134 49.8907 66.4349 49.783 66.4349L49.8045 66.4134ZM20.9425 43.7376L49.0717 64.2579V23.7562L39.9539 30.2011L20.9425 43.7592V43.7376Z",
    fill: "#343333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPear);
export default __webpack_public_path__ + "static/media/Pear.a9a09ed916016d77f91d7ad805917bdd.svg";
export { ForwardRef as ReactComponent };